const Builder = require('./BuilderBase');

module.exports = class hiddenFor extends Builder {
    constructor(role) {
        super('accessModifier_HiddenFor', null, { hiddenfor: role.toUpperCase() });
    }
};
